<script setup lang="ts">
const { theme } = useSiteTheme()

// Valeur statique : sert uniquement au rendu SSR initial (pas de re-render réactif ici)
useHead({
  htmlAttrs: {
    class: theme.value.htmlClass,
  },
})

// Bascule manuelle de la classe lors des navigations suivantes, côté client uniquement
if (process.client) {
  watch(
    () => theme.value.htmlClass,
    (newClass, oldClass) => {
      if (oldClass && oldClass !== newClass) {
        document.documentElement.classList.remove(oldClass)
      }
      document.documentElement.classList.add(newClass)
    }
  )
}
</script>

<template>
    <div>
        <a href="#contenu"
            class="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:bg-white focus:px-4 focus:py-3 focus:text-sm focus:font-semibold focus:text-slate-900 focus:shadow-lg">
            Aller au contenu
        </a>
        <TheHeader />
        <div class="overflow-x-hidden">
            <main id="contenu" tabindex="-1" class="outline-none">
                <slot />
            </main>
        </div>
        <TheFooter />
    </div>
</template>